import { render, staticRenderFns } from "./CoozzyArrowUpIcon.vue?vue&type=template&id=4beeec48&scoped=true"
import script from "./CoozzyArrowUpIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyArrowUpIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyArrowUpIcon.vue?vue&type=style&index=0&id=4beeec48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beeec48",
  null
  
)

export default component.exports